import React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import UploadIcon from '~/Components/Global/Assets/Svgs/UploadIcon';
import {
  CONFIRM_STICKER_REMOVAL_MODAL,
  STICKER_EDIT_TAGS_MODAL,
  UPLOAD_STICKERS_MODAL,
} from '~/Config/Modals';
import { STICKER_PACKS } from '~/Config/Products';
import { openModal, setModalData } from '~/Redux/Modules/Modal';

import CloseIcon from '../Assets/Svgs/CloseIcon';
import NoScrollBar from '../NoScrollBar/NoScrollBar';
import StickerDrag from './StickerDrag';

const CustomStickers = () => {
  const dispatch = useDispatch();

  const stickerPack = useSelector(state => {
    const stickerPacks = state.Products[STICKER_PACKS];
    return stickerPacks.filter(pack => pack.user_id != null)?.[0];
  });

  const handleStickerRemoval = (sticker, event) => {
    event.stopPropagation();
    dispatch(setModalData({ sticker: sticker }));
    dispatch(openModal(CONFIRM_STICKER_REMOVAL_MODAL));
  };

  const handleEditSticker = sticker => {
    console.log('Click');
    dispatch(setModalData({ sticker: sticker }));
    dispatch(openModal(STICKER_EDIT_TAGS_MODAL));
  };

  return (
    <div className="sticker-packs">
      <NoScrollBar showScrollOnHover>
        <div className="sticker-pack active">
          <div className="product">
            <div className="premium center">MY STICKERS</div>
          </div>

          <button className="btn pill" onClick={() => dispatch(openModal(UPLOAD_STICKERS_MODAL))}>
            <UploadIcon />
            UPLOAD
          </button>

          {stickerPack &&
            stickerPack.stickers.map((sticker, index) => (
              <div
                key={`container_${index}`}
                className="sticker-container"
                onClick={() => handleEditSticker(sticker)}
              >
                <div
                  key={`delete_button_${index}`}
                  className="sticker-delete-button"
                  role="button"
                  tabIndex="0"
                  onClick={event => handleStickerRemoval(sticker, event)}
                >
                  <CloseIcon key={`close_icon_${index}`} />
                </div>

                <StickerDrag
                  key={`sticker_drag_${index}`}
                  showDelete={false}
                  sticker={{
                    ...sticker,
                    pivot: {
                      sticker_id: sticker.id,
                      sticker_pack_id: stickerPack.id,
                    },
                  }}
                />
              </div>
            ))}
        </div>
      </NoScrollBar>
    </div>
  );
};

CustomStickers.propTypes = {};

export default CustomStickers;
